import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledBackgroundStack = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "100%",
  justifyContent: "start",
  alignItems: "center",
  overflow: "auto",
  padding: "50px",
  backgroundColor: theme.palette.hubColors.blueMainTransparent?.replace(
    "0.1",
    "0.025",
  ),
  backgroundImage: "radial-gradient(#999 1px, transparent 0)",
  backgroundSize: "20px 20px",
  backgroundRepeat: "repeat",
  "::-webkit-scrollbar": {
    display: "none",
  },
}));

export const StyledLabelStack = styled(Stack, {
  shouldForwardProp: (prop) => !["gap", "size"].includes(prop),
})(({ theme, gap = "5px", size = "2.625in 1in" }) => ({
  gap,
  boxShadow: "0px 0px 50px rgba(0, 0, 0, 0.3)",
  border: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  backgroundColor: theme.palette.hubColors.greyLightest,
  padding: "5px",
  borderRadius: "5px",
  "@page": { size, margin: 0 },
  "@media print": {
    backgroundColor: theme.palette.hubColors.white,
    transform: "scale(1.5)",
    transformOrigin: "top left",
    boxShadow: "none",
    border: "none",
    backgroundColor: "white",
    padding: "0px",
    borderRadius: "0px",
    ".HubDashedLine-root": {
      display: "none",
    },
  },
}));
